import { useContext, useEffect } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Card } from "../components/Shared/Card";
import { Colour } from "../Variables";
import { UsernameRecoveryForm } from "../components/Forms/UsernameRecoveryForm";
import { PasswordRecoveryForm } from "../components/Forms/PasswordRecoveryForm";

export function ForgotPassword() {
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Forgot password / username", route: null }])
    }, []);

    return (
        <>
            <InfoBanner
                header="Forgot password / username"
                narrow={false}
                icon={InfoHeaderIcon.Register}
                info={""}
                subHeader={`Password reset and username recovery utility`}
                theme={Colour.Primary}>
                <div>If you are still having issues please contact <a className="" href='mailto:support@allhires.com'>support@allhires.com</a> for assistance</div>
            </InfoBanner>


            <Card headerClasses="" title="Forgot password" headerTheme={Colour.Secondary}>
                <PasswordRecoveryForm />
            </Card>

            <Card headerClasses="" title="Forgot username" headerTheme={Colour.Secondary}>
                <UsernameRecoveryForm />
            </Card>
        </>
    );
}